.gate {
  min-height: 100%;
  display: grid;
  place-items: center;
  padding: 32px 16px;
}

.card {
  width: min(460px, 100%);
  padding: 32px;
  border-radius: var(--radius-large);
  background: linear-gradient(160deg, rgb(255 255 255 / 0.09), rgb(255 255 255 / 0.03));
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-panel);
  backdrop-filter: blur(18px);
  display: grid;
  gap: 20px;
  text-align: center;
}

.card > :global(*) {
  text-align: left;
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-size: 1.9rem;
  text-align: center !important;
}

.text {
  margin: -12px 0 0;
  color: var(--color-text-muted);
  text-align: center !important;
}

.codeInput {
  width: 100%;
  padding: 14px;
  border-radius: var(--radius);
  border: 1px solid var(--color-border);
  background: rgb(0 0 0 / 0.3);
  font-family: ui-monospace, 'Cascadia Code', Menlo, monospace;
  font-size: 1.6rem;
  letter-spacing: 0.4em;
  text-align: center !important;
  text-transform: uppercase;
}

.codeInput:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 4px rgb(232 184 79 / 0.18);
}

.error {
  margin: 0;
  color: #ffb4b4;
  text-align: center !important;
}

.waiting {
  min-height: 100%;
  display: grid;
  place-content: center;
  justify-items: center;
  gap: 24px;
  color: var(--color-text-muted);
  font-family: var(--font-display);
  font-size: 1.3rem;
}

.shuffle {
  position: relative;
  width: 60px;
  height: 84px;
}

.shuffleCard {
  position: absolute;
  inset: 0;
  border-radius: 8px;
  border: 4px solid #fff;
  background: repeating-linear-gradient(
    45deg,
    var(--color-card-back) 0 5px,
    var(--color-card-back-pattern) 5px 10px
  );
  box-shadow: 0 8px 20px rgb(0 0 0 / 0.4);
}
